import React, { useState, useEffect } from "react";
import Styles from "./Ongoing_Connections_Table.module.css";
import { Skeleton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useSelector } from "react-redux";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "../../../../../commons/Accordion";
import { LeftButton, RightButton } from "./ViewButtons";
import { formatSlotTime } from "../../../../../helpers/dateFormat";

const OngoingBilateralTable = ({
  data,
  isLoading,
  currentPage,
  itemsPerPage,
  totalCount,
  onPageChange,
}) => {
  const [expanded, setExpanded] = useState(null);
  // const [isLoading, setIsLoading] = useState(true);

  const { generator, consumer } = useSelector(
    (state) => state.persistedReducer
  );
  const isConsumer = !!consumer;

  // useEffect(() => {
  //   // Set loading state to false once data is received.
  //   if (data && data.length > 0) {
  //     setIsLoading(false);
  //   } else {
  //     setIsLoading(true);
  //   }
  // }, [data]);

  const totalPages = Math.ceil(totalCount / itemsPerPage);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = String(date.getDate()).padStart(2, "0");
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  const toggleAccordion = (index) =>
    setExpanded((prev) => (prev === index ? null : index));

  const skeletonRowCount = data?.length > 0 ? data.length : 8;

  if (!isLoading && (!data || data.length === 0)) {
    return <div></div>;
  }

  return (
    <div className={Styles.ongoingBankingMainContainer}>
      <div className={`display_flex_row_center ${Styles.tableActiveCont}`}>
        <div className={`${Styles.tableHeaderActive} display_flex_row`}>
          <div style={{ width: "1%" }}></div>
          <div style={{ width: "35%", paddingRight: "80px" }}>Listing ID</div>
          <div style={{ width: "25%", paddingRight: "80px" }}>
            Initial Margin
          </div>
          <div
            style={{ width: "25%", paddingRight: "70px", paddingLeft: "30px" }}
          >
            EMD
          </div>
          <div style={{ width: "30%", paddingLeft: "80px" }}>
            Listing Expiry Date
          </div>
          <div style={{ width: "30%", paddingLeft: "80px" }}>
            Terms Expiry Date
          </div>
        </div>
      </div>
      <div className={`${Styles.tableContentOngoing}`}>
        {isLoading ? (
          <div className={`scroll_bar_y ${Styles.tableContentActive}`}>
            {Array.from({ length: skeletonRowCount }).map((_, i) => (
              <div
                key={i}
                className={`${Styles.activeAccordion} ${
                  i % 2 === 0 ? Styles.accordionEven : Styles.accordionOdd
                }`}
                style={{
                  minHeight: 45,
                  marginBottom: "2px",
                }}
              >
                <div
                  className={`display_flex_row ${Styles.tableActiveCont}`}
                  style={{
                    minHeight: 45,
                    alignItems: "center",
                  }}
                >
                  <div className={Styles.tableAccordionData}>
                    <div style={{ width: "2%" }}>
                      <Skeleton variant="circular" width={24} height={24} />
                    </div>
                    <div style={{ width: "12%" }}>
                      <Skeleton variant="text" width="90%" height={20} />
                    </div>
                    <div style={{ width: "10%" }}>
                      <Skeleton variant="text" width="90%" height={20} />
                    </div>
                    <div style={{ width: "8%" }}>
                      <Skeleton variant="text" width="90%" height={20} />
                    </div>
                    <div style={{ width: "15%" }}>
                      <Skeleton variant="text" width="90%" height={20} />
                    </div>
                    <div style={{ width: "15%" }}>
                      <Skeleton variant="text" width="90%" height={20} />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className={`scroll_bar_y ${Styles.tableContentActive}`}>
            {data.map((item, i) => {
              return (
                <Accordion
                  key={i}
                  expanded={expanded === i}
                  onChange={() => toggleAccordion(i)}
                  className={`${Styles.activeAccordion} ${
                    expanded === i ? Styles.expandedAccordion : ""
                  }`}
                >
                  <AccordionSummary sx={{ minHeight: 45 }}>
                    <div
                      className={`display_flex_row ${Styles.tableActiveCont} ${
                        expanded === i
                          ? Styles.expandedRow
                          : i % 2 === 0
                          ? Styles.accordionEven
                          : Styles.accordionOdd
                      }`}
                    >
                      <div className={Styles.tableAccordionData}>
                        <div style={{ width: "5%" }}>
                          <div
                            style={{
                              width: 24,
                              height: 24,
                              position: "absolute",
                              top: "50%",
                              transform: "translate(-50%, -50%)",
                              color: "#C5C5CBD9",
                            }}
                          >
                            <ExpandMoreIcon
                              className={`${Styles.expandIconLeft} ${
                                expanded === i ? Styles.rotateIcon : ""
                              }`}
                              style={{
                                width: 24,
                                height: 24,
                              }}
                            />
                          </div>
                        </div>
                        <div
                          style={{ width: "35%" }}
                          className={Styles.companyLeft}
                        >
                          {item.listingName}
                        </div>
                        <div style={{ width: "25%", paddingRight: "70px" }}>
                          {item.initialMargin}%
                        </div>
                        <div style={{ width: "25%", paddingRight: "85px" }}>
                          {item.emd}₹/KWh
                        </div>
                        <div style={{ width: "30%", paddingRight: "30px" }}>
                          {formatDate(item.listingExpiryDate)}
                        </div>
                        <div style={{ width: "30%", paddingRight: "10px" }}>
                          {formatDate(item.termExpiryDate)}
                        </div>
                      </div>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className={Styles.accordianContainer}>
                      <div className={Styles.counterpartyCOntainer}>
                        <div className={Styles.headerBox}>
                          <span style={{ paddingLeft: "12px" }}>
                            Contacts Formed
                          </span>
                          <span style={{ paddingRight: "22px" }}>Quantity</span>
                          <span style={{ paddingRight: "28px" }}>
                            Energy Rate
                          </span>
                          <span style={{ paddingRight: "2px" }}>
                            Date Range
                          </span>
                          <span style={{ paddingRight: "45px" }}>
                            Time Range
                          </span>
                        </div>
                        <div className={Styles.slotContainer}>
                          {/* <h4 className={`display_flex_row ${Styles.accHeaderTable_name}`}>{item.counterparty?.generatorName || item.counterparty?.consumerName}</h4> */}
                          <div className={Styles.companyName}>
                            {" "}
                            <span className={Styles.company_title}>
                              {item.counterparty?.generatorName ||
                                item.counterparty?.consumerName}{" "}
                            </span>{" "}
                          </div>
                          {item.bilateralConnections?.map((slot, idx) => (
                            //  <div key={slot.id} className={Styles.slotbox}>
                            //    <span style={{ paddingLeft: "6px", paddingRight:"60px" }}>Contract {idx + 1}</span>
                            //    <span style={{paddingLeft: "100px" }}>{slot.quantity} (MW)</span>
                            //    <span style={{paddingLeft: "150px"}}> {slot.amount} (₹/kWh)</span>
                            //    <span style={{ paddingLeft: "100px" }}>{formatDate(slot.dateStartAt)} - {formatDate(slot.dateEndAt)}</span>
                            //    <span style={{paddingLeft:"40px" }}>{slot.slotStartAt} - {slot.slotEndAt}</span>
                            //   </div>
                            //   ))}
                            <div
                              key={slot.id}
                              className={Styles.slotbox}
                              style={{
                                display: "grid",
                                gridTemplateColumns:
                                  "150px 160px 220px 240px 200px",
                                alignItems: "center",
                                columnGap: "0px",
                              }}
                            >
                              <span
                                style={{
                                  paddingRight: "75px",
                                  paddingLeft: "0px",
                                }}
                              >
                                Contract {idx + 1}
                              </span>
                              <span
                                style={{
                                  paddingRight: "0px",
                                  paddingLeft: "85px",
                                }}
                              >
                                {slot.quantity} (MW)
                              </span>
                              <span
                                style={{
                                  paddingRight: "0px",
                                  paddingLeft: "113px",
                                }}
                              >
                                {slot?.energyRateType === "FIXED"
                                  ? `${slot?.amount?.toFixed(2)}`
                                  : slot?.energyRateType === "DAM_PLUS"
                                  ? `DAM+${slot?.amount}`
                                  : `DAM-${slot?.amount}`}{" "}
                                (₹/kWh)
                              </span>
                              <span
                                style={{
                                  paddingRight: "0px",
                                  paddingLeft: "75px",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {formatDate(slot.dateStartAt)} -{" "}
                                {formatDate(slot.dateEndAt)}
                              </span>
                              <span
                                style={{
                                  paddingRight: "0px",
                                  paddingLeft: "55px",
                                }}
                              >
                                {formatSlotTime(slot.slotStartAt)} -{" "}
                                {formatSlotTime(slot.slotEndAt)}
                              </span>
                            </div>
                          ))}
                          <div className={Styles.buttonbox}>
                            {console.log("the id is", i)}
                            <LeftButton
                              clickedIndex={i}
                              status={item.status}
                              item={item}
                              counterparty={item.counterparty}
                              source={item.source}
                            />
                            {/* <span className={Styles.rightBtn}>
                               {" "}
                              <RightButton
                                clickedIndex={i}
                                status={item.status}
                                item={item}
                              /> 
                            </span> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </div>
        )}
        <div className={Styles.paginationWrapper}>
          <button
            disabled={currentPage <= 0}
            onClick={() => onPageChange(currentPage - 1)}
          >
            Previous
          </button>
          <span>
            Page {currentPage + 1} of {totalPages}
          </span>
          <button
            disabled={currentPage + 1 >= totalPages}
            onClick={() => onPageChange(currentPage + 1)}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default OngoingBilateralTable;
